import Login from 'pages/Login';
import { lazy } from 'react';

const AllChecklists = lazy(() => import('pages/Admin/AllChecklists'));
const Checklist = lazy(() => import('pages/Admin/Checklist'));
const FormDesign = lazy(() => import('pages/Admin/FormDesign'));
const ChecklistPreview = lazy(() => import('pages/Admin/ChecklistPreview'));
const Dashboard = lazy(() => import('pages/Admin/Dashboard'));
const ApplicationSettings = lazy(() => import('pages/Admin/Settings'));
const Hospitals = lazy(() => import('pages/Admin/Hospitals'));
const Patients = lazy(() => import('pages/Admin/Patients'));
const AdminPatientDashboard = lazy(() => import('pages/Admin/PatientDetail'));

const Wards = lazy(() => import('pages/Admin/Wards'));
const Beds = lazy(() => import('pages/Admin/Beds'));
const Harms = lazy(() => import('pages/Admin/Harms'));
const PatentLabel = lazy(() => import('pages/Admin/PatientLabel'));

const EmrLabel = lazy(() => import('pages/Admin/EmrLabel'));
const MachineLearning = lazy(() => import('pages/Admin/MachineLearning'));
const MachineLearningDetails = lazy(
	() => import('pages/Admin/MachineLearningDetails')
);
const Logics = lazy(() => import('pages/Admin/Logics'));
const LogicDetail = lazy(() => import('pages/Admin/LogicDetail'));

const Kpi = lazy(() => import('pages/Admin/KPI'));
const KpiDetail = lazy(() => import('pages/Admin/KpiDetail'));

const Users = lazy(() => import('pages/Admin/Users'));
const UserDetail = lazy(() => import('pages/Admin/UserDetail'));

const Roles = lazy(() => import('pages/Admin/Roles'));
const RoleDetail = lazy(() => import('pages/Admin/RoleDetail'));

const routes = [
	{
		path: '/',
		name: 'Dashboard',
		component: Dashboard,
	},
	{
		path: '/settings',
		name: 'Settings',
		component: ApplicationSettings,
	},
	{
		path: '/allChecklists',
		name: 'All Checklists',
		component: AllChecklists,
	},
	{
		path: '/checklist/:checklistId',
		name: 'Checklist',
		component: Checklist,
	},
	{
		path: '/formDesign/:checklistId/',
		name: 'Collection',
		component: FormDesign,
	},
	{
		path: '/formDesign/preview/:checklistId/',
		name: 'Checklist Preview',
		component: ChecklistPreview,
	},

	{
		path: '/hospitals',
		name: 'Hospital',
		component: Hospitals,
	},

	{
		path: '/hospital/:hospitalId',
		name: 'Wards',
		component: Wards,
	},
	{
		path: '/patients',
		name: 'Patients',
		component: Patients,
	},
	{
		path: '/patients/:patientId',
		name: 'Patient Detail',
		component: AdminPatientDashboard,
	},

	{
		path: '/ward/:wardId',
		name: 'Beds',
		component: Beds,
	},

	{
		path: '/harms',
		name: 'Harms',
		component: Harms,
	},
	{
		path: '/patientLabel',
		name: 'PatientLabel',
		component: PatentLabel,
	},
	{
		path: '/emrLabel',
		name: 'Emr Label',
		component: EmrLabel,
	},
	{
		path: '/ml',
		name: 'ML',
		component: MachineLearning,
	},
	{
		path: '/ml/:harmType',
		name: 'ML',
		component: MachineLearningDetails,
	},
	{
		path: '/logics',
		name: 'Logic',
		component: Logics,
	},
	{
		path: '/logics/:logicId',
		name: 'LogicDetail',
		component: LogicDetail,
	},
	{
		path: '/kpi',
		name: 'KPI',
		component: Kpi,
	},
	{
		path: '/kpi/:kpiId',
		name: 'Kpi Details',
		component: KpiDetail,
	},
	{
		path: '/users',
		name: 'Users',
		component: Users,
	},
	{
		path: '/users/:id',
		name: 'User Details',
		component: UserDetail,
	},
	{
		path: '/roles',
		name: 'Roles',
		component: Roles,
	},
	{
		path: '/roles/:id',
		name: 'Role Details',
		component: RoleDetail,
	},
];

const adminRoutes = routes.map((r) => ({ ...r, path: '/admin' + r.path }));

export default adminRoutes;
